import { Box, Link, Typography } from "@mui/material";
import "../CSS/Layout.css";
import "../CSS/Publications.css";
import { publications } from "../Configurations/PublicationList";

export default function PublicationsPage() {
  function publicationSection() {
    const pubs = [];
    for (var i = publications.length; i > 0; i--) {
      let piece = publications[publications.length - i];
      pubs.push(
        <Box className="one-pub" key={i}>
          <Box >
            <Typography color="primary" fontWeight={800} fontSize="1.5rem">{i}</Typography>
          </Box>
          <Typography component="p" className="pub-text">
            {piece.citation.trim()}
            {" "}
            <Link
              component="a"
              href={piece.doiLink}
              color="primary"
              underline="hover"
              target="_blank"
              rel="noopener"
            >
              {piece.doi.trim()}
            </Link>
            {" "}
            {piece.specialDescription}
          </Typography>
          {piece.image && <img src={piece.image} className="pub-image" alt={i} />}
        </Box>
      );
    }
    return pubs;
  }
  return (<Box >
    {publicationSection()}
  </Box>);
}